import { PureAbility } from "@casl/ability";

import { type User, UserRole } from "@/types/user";

export enum Subject {
  MainDashboard = "MainDashboard",
  ManagingDashboard = "ManagingDashboard",
  Auditor = "Auditor",
  Driver = "Driver",
  Transaction = "Transaction",
  Corrections = "Corrections",
  User = "User",
  
  AllUnits = "AllUnits",
  Logs = "Logs",
  Reports = "Reports",
  Billing = "Billing",
  Tracking = "Tracking",
  Complaints = "Complaints",
  Vehicle = "Vehicle",
  Maintenance = "Maintenance",
  Chat = "Alarm",
  Resource = "Resource",
  Settings = "Settings",
  ProfileChangePassword = "ProfileChangePassword",
  Device = "Device",
  ApiKey = "Api Key",
  DriverLogs = "Driver Logs",
  Dvir = "DVIR",
  Violations = "Violations"
}

export enum Action {
  View = "view",
  Create = "create",
  Update = "update",
  Delete = "delete",
  Open = "open",
}

const subjects = [
  // Main dashboard subject
  {
    name: Subject.MainDashboard,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Managing dashboard
  {
    name: Subject.ManagingDashboard,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Manager, UserRole.Assistant, UserRole.Superadmin],
      },
    ],
  },
  // Auditor
  {
    name: Subject.Auditor,
    actions: [
      { name: Action.View, roles: [UserRole.Superadmin, UserRole.Manager] },
    ],
  },
  // Driver
  {
    name: Subject.Driver,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Create,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Delete,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Update,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Device
  {
    name: Subject.Device,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Create,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Delete,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Update,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
    ],
  },

  //     name: Subject.DriverLogs,
  {
    name: Subject.DriverLogs,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // Transaction
  {
    name: Subject.Transaction,
    actions: [
      {
        name: Action.Open,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // Violations
  {
    name: Subject.Violations,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // User
  {
    name: Subject.User,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Companyadmin, UserRole.Manager, UserRole.Superadmin],
      },
      {
        name: Action.Create,
        roles: [UserRole.Companyadmin, UserRole.Manager, UserRole.Superadmin],
      },
      {
        name: Action.Update,
        roles: [UserRole.Companyadmin, UserRole.Manager, UserRole.Superadmin],
      },
      {
        name: Action.Delete,
        roles: [UserRole.Companyadmin, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // All Units
  {
    name: Subject.AllUnits,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // All Logs,
  {
    name: Subject.Logs,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Companyadmin,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Reports
  {
    name: Subject.Reports,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // Billing
  {
    name: Subject.Billing,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
        ],
      },
    ],
  },
  // Tracking
  {
    name: Subject.Tracking,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // Complaints
  {
    name: Subject.Complaints,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },

  //     name: Subject.Connections,
  {
    name: Subject.Corrections,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },

  // Api key
  {
    name: Subject.ApiKey,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin, UserRole.Companyadmin],
      },
    ],
  },

  // DVIR
  {
    name: Subject.Dvir,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Assistant, UserRole.Manager, UserRole.Superadmin],
      },
    ],
  },
  // Vehicle
  {
    name: Subject.Vehicle,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Create,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Update,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
      {
        name: Action.Delete,
        roles: [
          UserRole.Companyadmin,
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Maintenance
  {
    name: Subject.Maintenance,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Manager,
          UserRole.Assistant,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Chat
  {
    name: Subject.Chat,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Manager,
          UserRole.Assistant,
          UserRole.Superadmin,
        ],
      },
    ],
  },
  // Resource
  {
    name: Subject.Resource,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Companyadmin,
          UserRole.Manager,
          UserRole.Assistant,
          UserRole.Companyadmin,
        ],
      },
    ],
  },
  // Settings
  {
    name: Subject.Settings,
    actions: [
      {
        name: Action.View,
        roles: [
          UserRole.Assistant,
          UserRole.Manager,
          UserRole.Superadmin,
          UserRole.Companyadmin,
        ],
      },
    ],
  },
  {
    name: Subject.ProfileChangePassword,
    actions: [
      {
        name: Action.View,
        roles: [UserRole.Superadmin, UserRole.Companyadmin, UserRole.Manager],
      },
    ],
  },
];

export const ability = new PureAbility();

export function defineAbilityFor(user: User) {
  const rules = subjects.flatMap((subject) =>
    subject.actions.map((action) => ({
      action: action.name.toString(),
      subject: subject.name.toString(),
      inverted: !user.role || !action.roles.includes(user.role),
    }))
  );
  ability.update(rules);
}
